import { initializeNeuroApplication } from '@ignitesales/neuro-application';
import commerceOnlineConsumerReducer from '../reducers/commerce-online-consumer-reducer.mjs';
import App from '../App';
import AppLoading from '../AppLoading';
import loadFonts from '../utils/loadFonts';
import logger from '../utils/logger.mjs';
import messages from '../i18n/messages';
import customMessages from "../i18n/custom";
import saveParameters from '../utils/saveParameters.mjs';

//TODO: no longer need template content once client UI/UX is implemented
const initGuide = async () => {
  loadFonts();

  await initializeNeuroApplication({
    AppComponent: App,
    AppLoadingComponent: AppLoading,
    messages: messages,
    reducers: [ commerceOnlineConsumerReducer ],
    guideConfig: {
      customMessages: customMessages,
      deepLinking: {
        pathMap: {
          checking: {
            path: 'productTypePreference-page',
            value: 'checking',
            page: 'customerType-page'
          },
          lending: {
            path: 'productTypePreference-page',
            value: 'borrow',
            page: 'customerType-page'
          },
          creditCard: {
            path: 'productTypePreference-page',
            value: 'creditCard',
            page: 'customerType-page'
          },
          savings:{
            path: 'productTypePreference-page',
            value: 'savings',
            page: 'customerType-page'
          }
        },
        shouldUpdateAnswer: 'productTypePreference'
      }
    }
  });

  await saveParameters();
  logger.info('Guide application is ready for takeoff!');
};

initGuide();
